import type { ContentfulImageSchema } from '@ecomm/contentful-components'
import type { DetailBubbleProps } from './DetailBubble'
import { DetailBubbles } from './DetailBubbles'
import { Illustration } from './Illustration'
import { LegalDisclaimer } from './LegalDisclaimer'

export type AlarmMomentsTabProps = {
  readonly image: ContentfulImageSchema
  readonly details: ReadonlyArray<DetailBubbleProps>
  readonly disclaimers?: ReadonlyArray<string>
  readonly theme?: 'light' | 'dark'
  readonly illustrationClass?: string
}

export function AlarmMomentsTab({
  image,
  details,
  disclaimers,
  theme,
  illustrationClass
}: AlarmMomentsTabProps) {
  return (
    <>
      <Illustration image={image} className={illustrationClass} />
      <DetailBubbles bubbles={details} theme={theme || 'light'} />
      {disclaimers && <LegalDisclaimer text={disclaimers} />}
    </>
  )
}
